import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { LoginUser, reset } from "../../../features/authSlice";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faUnlockAlt } from "@fortawesome/free-solid-svg-icons";
import {
  Col,
  Row,
  Form,
  Card,
  Button,
  Container,
  InputGroup,
  Alert,
} from "@themesberg/react-bootstrap";
import { Link, useNavigate } from "react-router-dom";

import LogoKampus from "../../../assets/img/logo/unitomo_logo.png";
import KampusMerdeka from "../../../assets/img/logo/kampus_merdeka_logo.png";

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { isLoading, isSuccess, isError, data, message } = useSelector(
    (state) => state.auth
  );

  useEffect(() => {
    // Jika user masuk halaman ini, clear storage!
    localStorage.clear();

    if (isSuccess && data?.data) {
      localStorage.setItem(
        "userData",
        JSON.stringify({ status: data?.data?.status, id: data?.data?.id })
      );
      localStorage.setItem("token", data?.jwt_token);
      navigate("/dashboard");
    } else {
      // showFailedDialog({
      //   title: "Oops!",
      //   msg: "Something went wrong with server!",
      // })
    }
  }, [data, navigate, isSuccess]);

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(reset());

    dispatch(LoginUser({ username, password }));
  };

  return (
    <main>
      <Container>
        <Row className="align-items-center mt-2 gap-2">
          <Col>
            <img
              alt="logo kampus"
              src={LogoKampus}
              className="max-w-120 d-block mx-auto"
            />
          </Col>
          <Col>
            <img
              alt="logo kampus"
              src={KampusMerdeka}
              className="max-w-120 d-block mx-auto"
            />
          </Col>
        </Row>
      </Container>
      <section className="d-flex align-items-center my-5 mt-lg-6 mb-lg-5">
        <Container>
          <Row className="justify-content-center">
            <Col
              xs={12}
              className="d-flex align-items-center justify-content-center"
            >
              <div className="bg-white shadow-soft border rounded border-light p-4 p-lg-5 w-100 fmxw-500">
                <div className="text-center text-md-center mb-4 mt-md-0">
                  <h3 className="mb-0">Login</h3>
                </div>
                {isError ? (
                  <Alert variant="danger">{message?.message || message}</Alert>
                ) : null}

                <Form className="mt-4" onSubmit={handleSubmit}>
                  <Form.Group id="email" className="mb-4">
                    <Form.Label>Username/NIM</Form.Label>
                    <InputGroup>
                      <InputGroup.Text>
                        <FontAwesomeIcon icon={faEnvelope} />
                      </InputGroup.Text>
                      <Form.Control
                        autoFocus
                        required
                        type="text"
                        placeholder="username/nim"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                      />
                    </InputGroup>
                  </Form.Group>
                  <Form.Group>
                    <Form.Group id="password" className="mb-4">
                      <Form.Label>Password</Form.Label>
                      <InputGroup>
                        <InputGroup.Text>
                          <FontAwesomeIcon icon={faUnlockAlt} />
                        </InputGroup.Text>
                        <Form.Control
                          required
                          type="password"
                          placeholder="Password"
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                        />
                      </InputGroup>
                    </Form.Group>
                    <div className="d-flex justify-content-between align-items-center mb-4">
                      <Card.Link
                        className="small text-end"
                        href="/forget-password"
                      >
                        Lost password?
                      </Card.Link>
                    </div>
                  </Form.Group>
                  <Button
                    variant="primary"
                    type="submit"
                    className="w-100"
                    disabled={isLoading}
                  >
                    Sign in
                  </Button>
                </Form>

                <div className="d-flex justify-content-center align-items-center mt-4">
                  <span className="fw-normal">
                    Not registered?
                    <Card.Link as={Link} to="/signup" className="fw-bold">
                      {` Create account `}
                    </Card.Link>
                  </span>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </main>
  );
};

export default Login;
